import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default {
  async processFile(file, scale) {
    try {
      let pdfDocument;
      if (typeof file === 'string') {
        console.log('Processing PDF file:', file)
        
        // Try multiple approaches for URL handling
        let pdfUrl = file;
        
        // If it's a full URL, try to fetch and load as ArrayBuffer
        if (file.startsWith('http')) {
          try {
            console.log('Fetching PDF via HTTP:', pdfUrl)
            const response = await fetch(pdfUrl);
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const arrayBuffer = await response.arrayBuffer();
            pdfDocument = await pdfjs.getDocument(arrayBuffer).promise;
          } catch (fetchError) {
            console.warn('HTTP fetch failed, trying direct URL:', fetchError.message)
            // Fallback to direct URL loading
            pdfDocument = await pdfjs.getDocument(pdfUrl).promise;
          }
        } else {
          // Direct URL loading for relative paths
          pdfDocument = await pdfjs.getDocument(pdfUrl).promise;
        }
      } else if (file instanceof Blob) {
        // 如果file是Blob对象
        const arrayBuffer = await file.arrayBuffer();
        pdfDocument = await pdfjs.getDocument(arrayBuffer).promise;
      } else {
        throw new Error('Invalid file type');
      }

      const numPages = pdfDocument.numPages;
      const pages = [];

      for (let i = 1; i <= numPages; i++) {
        const page = await pdfDocument.getPage(i);
        const viewport = page.getViewport({ scale });
        pages.push({ pageNumber: i, viewport });
      }

      return { type: 'success', numPages, pages };
    } catch (error) {
      console.error('PDF processing error:', error);
      return { type: 'error', error: error.message };
    }
  }
};
